import { Box, Paper, Typography } from "@mui/material";

export const panelSx = {
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  bgcolor: "#fff",
  boxShadow: "0 6px 18px rgba(15, 23, 42, 0.035)",
};

export const OssPanel = ({ children, sx, ...props }) => (
  <Paper
    elevation={0}
    sx={{
      ...panelSx,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
);

export const OssSectionPanel = ({ title, children, sx = {} }) => (
  <OssPanel
    sx={{
      p: { xs: 2, md: 2.25 },
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      ...sx,
    }}
  >
    <Typography sx={{ fontSize: 16, fontWeight: 900, color: "#111827", mb: 1.75 }}>
      {title}
    </Typography>
    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      {children}
    </Box>
  </OssPanel>
);
